import React, { useState } from 'react';
import { Link, graphql } from 'gatsby';
import styled, { css } from 'styled-components';
import Image from 'gatsby-theme-core/src/components/image';
import Button from 'gatsby-theme-core/src/components/button/index';
import { ArrowRight } from 'gatsby-theme-pdv/src/components/icons';
import Sharing from './sharing';

export const query = graphql`
  fragment PodcastPreview on WpPodcast {
    menuOrder
    title
    date(formatString: "D MMMM YYYY", locale:"nl")
    excerpt
    podcastAcf {
      soundcloudButtonLink
      audioButtonLink
      itunesButtonLink
    }
    uri
    featuredImage {
      node {
        gatsbyImage(
          layout: CONSTRAINED
          placeholder: BLURRED
          width: 380
        )
      }
    }
  }
`;

const PodcastPreview = ({
  menuOrder,
  title,
  date,
  excerpt,
  podcastAcf: {
    soundcloudButtonLink,
    audioButtonLink,
    itunesButtonLink,
  },
  uri,
  featuredImage,
}) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <StyledPodcast open={isOpen}>
      <Heading onClick={() => setOpen(() => !isOpen)}>
        <NumberOfTheBeast>{menuOrder}</NumberOfTheBeast>
        <div>
          <Title open={isOpen} dangerouslySetInnerHTML={{ __html: title }} />
          <Date>Publicatie: {date}</Date>
        </div>
        <Arrow>
          {isOpen && (
            <svg
              aria-hidden="true"
              focusable="false"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                fill="currentColor"
                d="M4.465 366.475l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L224 178.053l195.494 195.493c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-211.05-211.051c-4.686-4.686-12.284-4.686-16.971 0L4.465 349.505c-4.687 4.686-4.687 12.284 0 16.97z"
              />
            </svg>
          )}
          {!isOpen && (
            <svg
              aria-hidden="true"
              focusable="false"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                fill="currentColor"
                d="M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z"
              />
            </svg>
          )}
        </Arrow>
      </Heading>
      {isOpen && (
        <Footing>
          {featuredImage?.node && (
            <div>
              <Image
                image={featuredImage.node}
                fallbackAlt={title}
              />
            </div>
          )}
          <div>
            <Exerpt dangerouslySetInnerHTML={{ __html: excerpt.replace('[&hellip;]', '') }} />
            <ReadmoreLink to={uri}>Lees meer<ArrowRight /></ReadmoreLink>
            <Sharing
              soundcloudButtonLink={soundcloudButtonLink}
              audioButtonLink={audioButtonLink}
              itunesButtonLink={itunesButtonLink}
            />
          </div>
        </Footing>
      )}
    </StyledPodcast>
  );
};

const StyledPodcast = styled.article`
  border-bottom: 1px solid ${(props) => props.theme.gray2};
  &:first-child {
    border-top: 1px solid ${(props) => props.theme.gray2};
  }
`;

const Heading = styled(Button).attrs({ wrapper: true })`
  width: 100%;
  flex-grow: 1;
  display: flex;
  align-items: flex-start;
  padding: 20px 0;
  text-align: left;

  &:focus {
    outline: 0;
  }
`;

const NumberOfTheBeast = styled.span`
  font-family: ${(props) => props.theme.standoutFontFamily};
  font-size: 1.222rem;
  font-weight: 700;
  color: ${(props) => props.theme.gray2};
  min-width: 56px;
`;

const Arrow = styled.div`
  flex-shrink: 1;
  margin-left: auto;
  color: ${(props) => props.theme.gray2};
  svg {
    width: 1rem;
  }
`;

const Title = styled.h2`
  margin: 0;
  flex-grow: 1;
  font-size: 1.222rem;
  font-family: ${(props) => props.theme.standoutFontFamily};
 ${(props) => props.open && css`
    color: ${props.theme.primaryColor};
 `}
`;

const Date = styled.span`
  color: ${(props) => props.theme.gray3};
  font-size: 0.8889rem;
  font-weight: 300;
`;

const Footing = styled.footer`
  margin-top: 10px;
  background-color: ${(props) => props.theme.gray1};
  padding: 15px;
  display: grid;
  grid-auto-rows: auto;
  grid-gap: ${(props) => props.theme.grid.gap};
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    grid-template-columns: 3fr 2fr;
    > *:first-child {
      order: 2;
    }

  }
`;

const Exerpt = styled.div`
  p {
    margin: 0;
    line-height: 150%;
  }
`;

const ReadmoreLink = styled(Link)`
  display: block;
  margin-top: 8px;
  text-decoration: none;
  color: ${(props) => props.theme.primaryColor};
  svg {
    width: .3rem;
    padding-left: 4px;
  }
`;

export default PodcastPreview;
